import { FeaturePermissionsIndex, HoldingUserPermissions } from "../types"
import { FeaturePermissionsTemplate } from "./templates"

type HubPermissions = HoldingUserPermissions["hub"]

export const sprayPlansHaloAudit: FeaturePermissionsTemplate<HubPermissions> ={
    type: "access",
    name: "Spray plans / Halo audit",
    isAvailable: u => u.sprayPlans?.read && u.sprayPlans?.auditPlans?.audit,
    selector: a => ({ enabled: Boolean(a.sprayPlans.haloAudit) }),
    checkDependencies: a => checkDependencies(a, ["sprayPlans"]),
    nestedProperty: {
        parent: "sprayPlans",
        property: "haloAudit",
        setter: (target, value) => target.hub.sprayPlans.haloAudit = Boolean(value?.["enabled"])
    }
}

export const sprayPlansEnhancedAudit: FeaturePermissionsTemplate<HubPermissions> = {

    type: "access",
    name: "Spray plans / Enhanced audit",
    isAvailable: u => u.sprayPlans?.read && u.sprayPlans?.auditPlans?.audit,
    selector: a => ({ enabled: Boolean(a.sprayPlans.enhancedAudit) }),
    checkDependencies: a => checkDependencies(a, ["sprayPlans", "sprayPlansHaloAudit"]),
    nestedProperty: {
        parent: "sprayPlans",
        property: "enhancedAudit",
        setter: (target, value) => target.hub.sprayPlans.enhancedAudit = Boolean(value?.["enabled"])
    }

}




function checkDependencies(permissions: FeaturePermissionsIndex, properties: string[]) {

    function isOn(values: {}) {
        return values && ((values["enabled"] ?? values["read"]) === true)
    }

    return properties.every(p => {
        const key = `hub.${p}`
        const f = permissions[key]
        return f && isOn(f.values)
    })

}